import axios from "./index.service";

export default class DeliveryService {
  static create(data) {
    return axios({
      method: "POST",
      url: "v1/api/services/delivery-stations/",
      data: data,
    });
  }

  static getDeliveryStation(id) {
    return axios({
      method: "GET",
      url: `v1/api/services/delivery-stations/${id}`,
    });
  }

  static getDeliveryFees() {
    return axios({
      method: "GET",
      url: `v1/api/services/delivery-stations/`,
    });
  }

  static updateDeliveryStation(id, payload) {
    return axios({
      method: "PUT",
      url: `v1/api/services/delivery-stations/${id}`,
      data: payload,
    });
  }

  static deleteDeliveryStation(id) {
    return axios({
      method: "DELETE",
      url: `v1/api/services/delivery-stations/${id}`,
    });
  }

  static getStationNames() {
    return axios({
      method: "GET",
      url: `v1/api/services/delivery-stations/names`,
    });
  }
}
